import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "@/components/feature/SectionHeading";

export default function NewsFeed() {
  const featured = newsList[0];
  const rest = newsList.slice(1, 5);

  if (!featured) {
    return (
      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <SectionHeading eyebrow="NEWS" title="最新资讯" linkTo="/news" linkLabel="全部资讯" />
        <div className="rounded-lg border border-dashed border-background-300 py-14 text-center text-sm text-foreground-500">
          暂无最新资讯
        </div>
      </section>
    );
  }

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="NEWS"
          title="最新资讯"
          description="汇聚欧冠赛场的内外动态、战报与深度分析。"
          linkTo="/news"
          linkLabel="全部资讯"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          <Link
            to={`/news/${featured.id}`}
            className="group relative rounded-lg overflow-hidden border border-background-200 min-h-[280px] md:min-h-[380px] flex flex-col justify-end bg-primary-950"
          >
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} 欧冠资讯`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-transparent"></div>
            <div className="relative p-5 md:p-7">
              <span className="inline-block rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-semibold text-background-50 mb-3">
                {featured.category}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 leading-snug">
                {featured.title}
              </h3>
              <p className="mt-2 text-sm text-background-200 line-clamp-2">{featured.summary}</p>
              <span className="mt-3 inline-flex items-center gap-2 text-xs text-background-300">
                <i className="ri-user-line" aria-hidden="true"></i>
                {featured.author} · {featured.date}
              </span>
            </div>
          </Link>

          <div className="flex flex-col gap-3 md:gap-4">
            {rest.map((n) => (
              <Link
                key={n.id}
                to={`/news/${n.id}`}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4 transition-colors hover:border-primary-300"
              >
                <div className="w-24 h-20 md:w-32 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-100">
                  <img
                    src={n.cover}
                    alt={n.title}
                    title={`${n.title} 欧冠资讯`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex flex-col justify-center">
                  <span className="text-[11px] font-semibold text-accent-600 mb-1">
                    {n.category} · {n.date}
                  </span>
                  <h4 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {n.title}
                  </h4>
                  <p className="mt-1.5 text-xs text-foreground-600 line-clamp-1 hidden sm:block">
                    {n.summary}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}